export const GHS    = 'ghs';
export const OA     = 'oa';
export const SHEETS = 'sheets';
export const RFID   = 'rfid';


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/category-types.ts